module.exports = __webpack_public_path__ + "img/tenant-detail.b433b6c0.png";